// Khu vực và ngôn ngữ nằm ở localStorage — server không đọc được. Ghi thêm một
// bản sang cookie để server biết mà dựng sẵn khung trang chủ đúng biến thể
// (xem server/controllers/cacheAPI/homePage.js).
//
// An toàn kể cả khi CloudFront không chuyển tiếp cookie: server không thấy cookie
// thì dùng mặc định, và client luôn đối chiếu region/lang/seed trong khối dựng sẵn
// trước khi dùng — lệch thì bỏ qua, không bao giờ hiển thị nhầm.
//
// Không đặt dữ liệu nhạy cảm ở đây: cookie này đi kèm mọi request và có thể lọt
// vào cache dùng chung.
const ONE_YEAR_SECONDS = 365 * 24 * 60 * 60;

export function setPreloadHintCookie(name: 'region' | 'lang', value: string): void {
  if (!value || !/^[a-zA-Z-]{2,10}$/.test(value)) {
    return;
  }
  try {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${name}=${value}; path=/; max-age=${ONE_YEAR_SECONDS}; SameSite=Lax${secure}`;
  } catch {}
}

/**
 * MỌI chỗ đổi ngôn ngữ phải đi qua đây — đừng gọi `localStorage.setItem('lang')`
 * trực tiếp.
 *
 * Vì sao: inline script ở đầu <head> (`internals/webpack/lcpEnBannerMeta.js`)
 * quyết định có preload chunk `i18n-en` + banner EN hay không, và nó CHỈ đọc
 * được cookie. Đọc localStorage ở đó sẽ buộc engine nạp cả store đồng bộ trước
 * FCP — chi phí đánh vào 100% khách, kể cả VI. Nên localStorage vẫn là nguồn
 * thật của app, cookie là bản sao cho critical path; hai cái phải ghi cùng lúc,
 * nếu lệch thì khách EN mất preload và quay lại chuỗi nối tiếp cũ (+1425ms tới
 * cuộc gọi API đầu tiên, đo QA 2026-08-03).
 */
export function setLang(value: string): void {
  try {
    window.localStorage.setItem('lang', value);
  } catch {}
  setPreloadHintCookie('lang', value);
}
